module.exports = __webpack_public_path__ + "img/sidebar-vehicle-detection.svg";